import { render, staticRenderFns } from "./NoAccountPage.vue?vue&type=template&id=422425c2&"
import script from "./NoAccountPage.vue?vue&type=script&lang=js&"
export * from "./NoAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports